import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { UserService } from './user.service';
import { environment } from './../environments/environment';
import { MessageService } from './message.service';
//import { S3Client, ListObjectsV2Command, ListBucketsCommand } from "@aws-sdk/client-s3";

@Injectable({
  providedIn: 'root'
})
export class WorkspaceService {

  downloadUrl = environment.s3ProxyUrl + '/s3filemgr/download';
  uploadUrl = environment.s3ProxyUrl + '/s3filemgr/upload';
  userWorkspaceInfo: UserWorkspaceInfo|undefined = undefined;
  fileInfos = signal<FileInfo[]>([]);
  uploadToken = signal<string|undefined>(undefined);
//  client: S3Client|undefined = undefined;

  constructor(private http: HttpClient, public userService: UserService, public messageService: MessageService) {
    if (this.userService.userInfo) {
      this.getUserWorkspaceInfo(this.userService.userInfo.userName, this.userService.accessToken);    
    }
   }

  getUserWorkspaceInfo(userName:string, accessToken:string): void {
    this.userWorkspaceInfo = undefined;
    let url = 'https://' + environment.workspaceApiPrefix + '.' 
      + environment.domain + '/workspaces/' + environment.userWorkspacePrefix
      + userName;

    this.http.get(url, {headers: new HttpHeaders({
      'Authorization': 'Bearer ' + accessToken,
      'Accept': 'application/json',
    })}).subscribe((data: any) => {
      console.log(data);
      let storage = data['storage'];
      if (storage) {
        let credentials = storage['credentials'];
        if (credentials) {
          let info = new UserWorkspaceInfo();
          info.access = credentials['access'];
          info.bucketname = credentials['bucketname'];
          info.projectid = credentials['projectid'];
          info.secret = credentials['secret'];
          info.endpoint = credentials['endpoint'];
          info.region = credentials['region'];
          this.userWorkspaceInfo = info;
//          this.client = new S3Client({
//            endpoint: info.endpoint,
//            region: info.region,
//            credentials: {accessKeyId:info.access, secretAccessKey:info.secret},
//          });
          this.refreshFileList();
        }
      }
    });
  }

//  async listFiles(): Promise<void> {
//    if (this.client && this.userWorkspaceInfo) {
//      const command = new ListObjectsV2Command({Bucket: this.userWorkspaceInfo.bucketname});
//      const command = new ListBucketsCommand({});
//      const response = await this.client.send(command);
//      console.log(response);
//    }
//  }

  listFiles(prefix:string, callback:Function): void {

    if (this.userWorkspaceInfo) {
      // Get CSRF token from server
      let token: string|undefined = undefined;
      this.http.get(environment.s3ProxyUrl + '/s3filemgr/list',
      {headers: new HttpHeaders({
        'Accept': 'text/html',
      }), responseType: 'text'}).subscribe(
        (response) => {
          //console.log(response)
          token = this.getTokenFromHTML(response.toString());
          // Get file list
          if (token) {
            const formData = new FormData();
            formData.set('csrfmiddlewaretoken', token);
            formData.set('endpoint', this.userWorkspaceInfo!.endpoint);
            formData.set('access', this.userWorkspaceInfo!.access);
            formData.set('secret', this.userWorkspaceInfo!.secret);
            formData.set('bucket', this.userWorkspaceInfo!.bucketname);
            formData.set('prefix', prefix);
            this.http.post(environment.s3ProxyUrl + '/s3filemgr/list', formData).subscribe(
              (data:any) => {
                //console.log(data);
                let fileArray = data['Contents'];
                let tmpFiles:FileInfo[] = [];
                if (fileArray) {
                  for (var i=0; i < fileArray.length; i++) {
                    if (!fileArray[i].Key.toString().endsWith('/')) {
                      let f = new FileInfo();
                      f.key = fileArray[i].Key;
                      f.lastmodified = fileArray[i].LastModified;
                      f.size = fileArray[i].Size;
                      
                      tmpFiles.push(f);
                    }
                  }
                }
                callback(tmpFiles);
              }
            );
          }
        }
      );
    }
  }

  updateFileList(list:FileInfo[], itemHref:string|undefined): void {
    this.fileInfos.set(list);
  }

  refreshFileList(): void {
    this.listFiles('', this.updateFileList.bind(this));
  }

  downloadFile(file:FileInfo): void {
    if (this.userWorkspaceInfo) {
      // Get CSRF token from server
      let token: string|undefined = undefined;
      this.http.get(this.downloadUrl,
      {headers: new HttpHeaders({
        'Accept': 'text/html',
      }), responseType: 'text'}).subscribe(
        (response) => {
          //console.log(response)
          token = this.getTokenFromHTML(response.toString());
          // Fill the hidden form and download the file using the browser's 
          // native download functionality
          if (token) {
            let tokenInput = document.getElementById('id_csrfmiddlewaretoken') as HTMLInputElement;
            let endpointInput = document.getElementById('id_endpoint') as HTMLInputElement;
            let accessInput = document.getElementById('id_access') as HTMLInputElement;
            let secretInput = document.getElementById('id_secret') as HTMLInputElement;
            let bucketInput = document.getElementById('id_bucket') as HTMLInputElement;
            let keyInput = document.getElementById('id_key') as HTMLInputElement;
            let submitButton = document.getElementById('id_submit') as HTMLElement;
            tokenInput.value = token;
            endpointInput.value = this.userWorkspaceInfo!.endpoint;
            accessInput.value = this.userWorkspaceInfo!.access;
            secretInput.value = this.userWorkspaceInfo!.secret;
            bucketInput.value = this.userWorkspaceInfo!.bucketname;
            keyInput.value = file.key;
            submitButton.click();
          }
        }
      );
    }
  }

  downloadFromUserS3(href:string): void {
    if (this.userWorkspaceInfo) {
      // Accept only S3 hrefs to the user bucket
      if (!href.startsWith('s3://' + this.userWorkspaceInfo!.bucketname + '/')) {
        return;
      }
      // Convert href to bucket key
      let key = href.replace('s3://' + this.userWorkspaceInfo!.bucketname + '/', '');

      // Get CSRF token from server
      let token: string|undefined = undefined;
      this.http.get(this.downloadUrl,
      {headers: new HttpHeaders({
        'Accept': 'text/html',
      }), responseType: 'text'}).subscribe(
        (response) => {
          //console.log(response)
          token = this.getTokenFromHTML(response.toString());
          console.log('token=' + token);
          // Fill the hidden form and download the file using the browser's 
          // native download functionality
          if (token) {
            let tokenInput = document.getElementById('id_csrfmiddlewaretoken') as HTMLInputElement;
            let endpointInput = document.getElementById('id_endpoint') as HTMLInputElement;
            let accessInput = document.getElementById('id_access') as HTMLInputElement;
            let secretInput = document.getElementById('id_secret') as HTMLInputElement;
            let bucketInput = document.getElementById('id_bucket') as HTMLInputElement;
            let keyInput = document.getElementById('id_key') as HTMLInputElement;
            let submitButton = document.getElementById('id_submit') as HTMLElement;
            tokenInput.value = token;
            endpointInput.value = this.userWorkspaceInfo!.endpoint;
            accessInput.value = this.userWorkspaceInfo!.access;
            secretInput.value = this.userWorkspaceInfo!.secret;
            bucketInput.value = this.userWorkspaceInfo!.bucketname;
            keyInput.value = key;
            //submitButton.click();
            let downloadForm = document.getElementById('downloadFormForm') as HTMLFormElement;
            downloadForm.requestSubmit();
            console.log('submit clicked');
          }
        }
      );
    }
  }

  getTokenFromHTML(str:string): string|undefined {
    let i = str.indexOf('csrfmiddlewaretoken');
    if (i > 0) {
      let j = str.indexOf('value="', i);
      if (j > 0) {
        let k = str.indexOf('"', j+7)
        if (k > 0) {
          return str.substring(j+7, k);
        }
      }
    }
    return undefined;
  }

  showUploadForm(): void {
    if (this.userWorkspaceInfo) {
      // Get CSRF token from server
      let token: string|undefined = undefined;
      this.http.get(this.uploadUrl,
      {headers: new HttpHeaders({
        'Accept': 'text/html',
      }), responseType: 'text'}).subscribe(
        (response) => {
          //console.log(response)
          this.uploadToken.set(this.getTokenFromHTML(response.toString()));
        }
      );
    }
  }

  hideUploadForm(): void {
    this.uploadToken.set(undefined);
  }

  submitUploadForm(): void {
    if (this.uploadToken() && this.userService.getUserInfo() && this.userWorkspaceInfo) {
      const formData = new FormData();
      let fileInput = document.getElementById('id_up_files') as HTMLInputElement;
      let bboxInput = document.getElementById('id_up_bbox') as HTMLInputElement;
      if (fileInput != null && fileInput.files != null && fileInput.files.length > 0 && bboxInput != null) {
        for (let i=0; i<fileInput.files.length; i++) {
          formData.append('file', fileInput.files[i]);
        }
        formData.set('bbox', bboxInput.value);
        formData.set('csrfmiddlewaretoken', this.uploadToken()!);
        formData.set('endpoint', this.userWorkspaceInfo.endpoint);
        formData.set('access', this.userWorkspaceInfo.access);
        formData.set('secret', this.userWorkspaceInfo.secret);
        formData.set('bucket', this.userWorkspaceInfo.bucketname);
        formData.set('project', this.userWorkspaceInfo.projectid);
        formData.set('user', environment.userWorkspacePrefix + this.userService.getUserInfo()!.userName);

        this.http.post(this.uploadUrl, formData, {observe: 'response'}).subscribe(
          resp => {
            console.log(resp);
            const keys = resp.headers.keys();
            if (resp.status == 200) {
              this.messageService.addMessage('Upload successful');
              this.refreshFileList();
              this.registerFile(resp.body);
            } else {
              this.messageService.addMessage('Upload failed (HTTP response ' + resp.status.toString() + ' ' + resp.statusText + ')');
            }
          }

//          (data:any) => {
//            console.log(data);
//            this.listFiles();
//          }
        );
      }
    }

    this.hideUploadForm();
  }

  registerFile(content:any): void {
    if (this.userService.getAccessToken() && this.userService.getUserInfo()) {
      let url = 'https://' + environment.workspaceApiPrefix + '.' 
        + environment.domain + '/workspaces/' + environment.userWorkspacePrefix
        + this.userService.getUserInfo()!.userName + '/register';
      this.http.post(url, content, 
        {headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.userService.getAccessToken(),
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }), observe: 'response'}).subscribe((resp) => {
        console.log(resp);
        if (resp.status == 200 || resp.status == 202) {
          this.messageService.addMessage('File registration successful');
        } else {
          this.messageService.addMessage('File registration failed (HTTP response ' + resp.status.toString() + ' ' + resp.statusText + ')');
        }
      });
   }
  }
}

export class UserWorkspaceInfo {
  public access: string = '';
  public bucketname: string = '';
  public projectid: string = '';
  public secret: string = '';
  public endpoint: string = '';
  public region: string = '';
}

export class FileInfo {
  public key: string = '';
  public size: string = '';
  public lastmodified: string = '';
  public resourceUrl: string|undefined = undefined;
  public itemHref: string|undefined = undefined;
}